module.exports = __webpack_public_path__ + "static/img/u1.422fd40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u1.png
// module id = gjia
// module chunks = 1